import React, { useState } from "react";
import { Tabs, Table, Collapse, Typography, Divider, Tag, message } from "antd";
import { Link } from "react-router-dom";
import Hero1 from "../assets/img/hero_1.webp";
import Hero2 from "../assets/img/hero_2.webp";
import Hero3 from "../assets/img/hero_3.webp";
import gif5 from "../assets/img/forage-step-0.gif";
import gif2 from "../assets/img/maze_reflex-episode-27.gif";
import gif3 from "../assets/img/rl-video-episode-1_mountain.gif";
import gif4 from "../assets/img/rl-video-episode-1.gif";
import gif1 from "../assets/img/rl-video-episode-2_acrobot.gif";
import gif6 from "../assets/img/swimmer-step-0.gif";
import Footer from "../components/Footer";
import HomeFAQ from "../components/home/faq";
import HomeNumbers from "../components/home/numbers";
import HomeTestimonials from "../components/home/testimonials";
import HomePricing from "../components/home/pricing";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselDots,
} from "../components/ui/carousel";
import { Button } from "../components/ui/button";
import Autoplay from "embla-carousel-autoplay";
import homeWork from "../assets/img/home_work.webp";
import "./Home.css";
import SDKDownloadModal from "../components/SDKDownloadModal";
import useUserStore from "../store/userStore";
import { useNavigate } from "react-router-dom";
import { apiService } from "../api/apiService";

const { Title, Text, Paragraph } = Typography;
const { Panel } = Collapse;

const Home = () => {
  const { isLoggedIn } = useUserStore();

  const [isSdkModalVisible, setIsSdkModalVisible] = useState(false);
  const navigate = useNavigate();

  const handleDownloadSDK = () => {
    if (!isLoggedIn) {
      navigate(`/login?redirect=${encodeURIComponent("/api-doc")}`);
      return;
    }
    setIsSdkModalVisible(true);
  };

  const handleModalClose = () => {
    setIsSdkModalVisible(false);
  };

  const handleSdkDownload = async (platform) => {
    if (platform !== "Linux") {
      message.info(`${platform}版本SDK尚未发布，敬请期待！`);
      return;
    }

    try {
      message.info(`正在下载${platform}版本SDK...`);
      const blob = await apiService.downloadApk();

      // 创建下载链接
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `stabilize-sdk-${platform.toLowerCase()}.apk`
      );

      // 触发下载
      document.body.appendChild(link);
      link.click();

      // 清理
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      message.success(`${platform}版本SDK下载成功！`);
    } catch (error) {
      console.error("SDK下载失败:", error);
      message.error(`SDK下载失败: ${error.message || "请稍后重试"}`);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 英雄区 */}
      <section className="bg-gradient-to-b from-blue-300 to-indigo-100 py-16 pt-20 pb-10">
        <Carousel
          className="w-full"
          opts={{ loop: true, dots: true }}
          plugins={[
            Autoplay({
              playOnInit: true,
              delay: 5000,
              // stopOnMouseEnter: true,
              stopOnInteraction: false,
            }),
          ]}
        >
          <CarouselContent>
            {/* 轮播卡片 1 */}
            <CarouselItem>
              <div className="container mx-auto px-4 pb-4">
                <div className="flex flex-col md:flex-row items-center gap-8">
                  <div className="flex-1">
                    <Title level={1} className="mb-4">
                      新一代人工智能
                    </Title>
                    <div className="text-gray-600 py-6 text-base">
                      具备自主学习和探索能力的真正的人工智能，具备自然生命的智力属性。
                    </div>
                    <div className="flex gap-4 mt-2 mb-6">
                      <Button
                        variant="blue-griadient"
                        size="lg"
                        onClick={handleDownloadSDK}
                      >
                        探索产品
                      </Button>
                      <Link to="/api-doc">
                        <Button variant="secondary" size="lg">
                          API文档
                        </Button>
                      </Link>
                    </div>
                  </div>
                  <div className="md:w-1/2 max-w-[400px]">
                    <img src={Hero3} />
                  </div>
                </div>
              </div>
            </CarouselItem>

            {/* 轮播卡片 2 */}
            <CarouselItem>
              <div className="container mx-auto px-4 pb-4">
                <div className="flex flex-col md:flex-row items-center gap-8">
                  <div className="flex-1">
                    <Title level={1} className="mb-4">
                      实现人工智能技术的产品化
                    </Title>
                    <div className="text-gray-600 py-6 text-base">
                      包括可学习自动控制模型和芯片、可学习模型和芯片等多种产品形态。
                    </div>
                    <div className="flex gap-4 mt-2 mb-6">
                      <Link to="/technology">
                        <Button variant="blue-griadient" size="lg">
                          了解更多
                        </Button>
                      </Link>
                      <Link to="/solutions">
                        <Button variant="secondary" size="lg">
                          查看案例
                        </Button>
                      </Link>
                    </div>
                  </div>
                  <div className="md:w-1/2 max-w-[400px]">
                    <img src={Hero1} />
                  </div>
                </div>
              </div>
            </CarouselItem>

            {/* 轮播卡片 3 */}
            <CarouselItem>
              <div className="container mx-auto px-4 pb-4">
                <div className="flex flex-col md:flex-row items-center gap-8">
                  <div className="flex-1">
                    <Title level={1} className="mb-4">
                      提供生产力，助力机器人产业的落地
                    </Title>
                    <div className="text-gray-600 py-6 text-base">
                      应用领域包括自动化领域、机器人领域和广义机器人领域。
                    </div>
                    <div className="flex gap-4 mt-2 mb-6">
                      <Button
                        variant="blue-griadient"
                        size="lg"
                        onClick={handleDownloadSDK}
                      >
                        立即体验
                      </Button>
                      <Link to="/about">
                        <Button variant="secondary" size="lg">
                          联系我们
                        </Button>
                      </Link>
                    </div>
                  </div>
                  <div className="md:w-1/2 max-w-[400px]">
                    <img src={Hero2} />
                  </div>
                </div>
              </div>
            </CarouselItem>
          </CarouselContent>
          <CarouselDots />
        </Carousel>
      </section>

      <section
        className="py-24 md:pb-32 bg-white bg-center"
        style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
      >
        <div className="container ">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100  uppercase rounded-full shadow-sm">
              核心功能
            </span>
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              强大的AI智能软件服务，赋能各类电子产品
            </h2>
            <p className="text-base md:text-lg text-slate-500">
              一款可以嵌入到各类电子产品中的AI智能软件服务，让您的产品拥有智能化体验，提升产品竞争力。
            </p>
          </div>
          <div className="flex flex-wrap -mx-4 text-slate-800">
            <div className="w-full md:w-1/2 lg:w-1/3 px-4">
              <div className="h-full p-8 text-center hover:bg-white rounded-md hover:shadow-xl transition duration-200">
                <div className="gif-container">
                  <img src={gif1} alt="GIF 1" />
                </div>
                <p className="text-slate-500 ">
                  强大的AI算法，实时分析设备数据，提供智能决策支持，提升产品智能化水平。
                </p>
              </div>
            </div>
            <div className="w-full md:w-1/2 lg:w-1/3 px-4">
              <div className="h-full p-8 text-center hover:bg-white rounded-md hover:shadow-xl transition duration-200">
                <div className="gif-container">
                  <img src={gif2} alt="GIF 2" />
                </div>
                <p className="text-slate-500 ">
                  实时采集和分析设备运行数据，提供可视化报表和智能预警，帮助用户更好地管理设备。
                </p>
              </div>
            </div>
            <div className="w-full md:w-1/2 lg:w-1/3 px-4">
              <div className="h-full p-8 text-center hover:bg-white rounded-md hover:shadow-xl transition duration-200">
                <div className="gif-container">
                  <img src={gif3} alt="GIF 3" />
                </div>
                <p className="text-slate-500 ">
                  内置智能安全防护系统，实时监控设备运行状态，及时发现并处理安全隐患，保障设备安全运行。
                </p>
              </div>
            </div>
            <div className="w-full md:w-1/2 lg:w-1/3 px-4">
              <div className="h-full p-8 text-center hover:bg-white rounded-md hover:shadow-xl transition duration-200">
                <div className="gif-container">
                  <img src={gif4} alt="GIF 4" />
                </div>
                <p className="text-slate-500 ">
                  支持智能语音交互功能，让用户可以通过语音控制设备，提供更加便捷的操作体验。
                </p>
              </div>
            </div>
            <div className="w-full md:w-1/2 lg:w-1/3 px-4">
              <div className="h-full p-8 text-center hover:bg-white rounded-md hover:shadow-xl transition duration-200">
                <div className="gif-container">
                  <img src={gif5} alt="GIF 5" />
                </div>
                <p className="text-slate-500 ">
                  支持多设备互联互通，实现设备之间的数据共享和协同工作，打造智能生态系统。
                </p>
              </div>
            </div>
            <div className="w-full md:w-1/2 lg:w-1/3 px-4">
              <div className="h-full p-8 text-center hover:bg-white rounded-md hover:shadow-xl transition duration-200">
                <div className="gif-container">
                  <img src={gif6} alt="GIF 6" />
                </div>
                <p className="text-slate-500 ">
                  提供简单易用的集成方案，支持多种设备平台，快速实现智能化升级，降低开发成本。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="py-24 bg-white overflow-hidden bg-center"
        style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
      >
        <div className="container ">
          <div className="flex flex-wrap -mx-4">
            <div className="w-full md:w-1/2 px-4 mb-16 md:mb-0">
              <div className="relative mx-auto md:ml-0 max-w-max">
                <img
                  className="absolute z-10 -right-8 -top-8 w-28 md:w-auto"
                  src="/img/circle3-yellow.svg"
                  alt=""
                  width={129}
                  height={129}
                />

                <img
                  className="absolute z-10 -left-10 -bottom-8 w-28 md:w-auto"
                  src="/img/dots3-blue.svg"
                  alt=""
                  width={149}
                  height={91}
                />

                <img src={homeWork} alt="" width={456} height={456} />
              </div>
            </div>
            <div className="w-full md:w-1/2 px-4">
              <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100  uppercase rounded-full shadow-sm">
                快速使用
              </span>
              <h2 className="mb-12 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
                快速实现设备的智能化
              </h2>
              <div className="flex flex-wrap -mx-4 text-center md:text-left text-slate-800">
                <div className="w-full md:w-1/2 px-4 mb-8">
                  <div className="inline-flex items-center justify-center mb-4 w-12 h-12 text-xl text-white bg-blue-600 font-semibold rounded-full">
                    1
                  </div>
                  <h3 className="mb-2 text-base md:text-lg font-bold">
                    选择产品和方案
                  </h3>
                  <p className=" text-slate-500">
                    根据你的设备情况，选择合适的产品和集成方案。
                  </p>
                </div>
                <div className="w-full md:w-1/2 px-4 mb-8">
                  <div className="inline-flex items-center justify-center mb-4 w-12 h-12 text-xl text-white bg-blue-600 font-semibold rounded-full">
                    2
                  </div>
                  <h3 className="mb-2 text-base md:text-lg font-bold">
                    集成产品到你的设备
                  </h3>
                  <p className=" text-slate-500">
                    将我们的产品安装到你的设备，可以参考相关产品的获取和使用文档。
                  </p>
                </div>
                <div className="w-full md:w-1/2 px-4 mb-8">
                  <div className="inline-flex items-center justify-center mb-4 w-12 h-12 text-xl text-white bg-blue-600 font-semibold rounded-full">
                    3
                  </div>
                  <h3 className="mb-2 text-base md:text-lg font-bold">
                    测试和调试
                  </h3>
                  <p className=" text-slate-500">
                    你可以在你的设备上进行充分的测试和调试，由于模型具备自主学习
                    能力，你可能需要让它自主学习一会儿，直到它的表现符合你的需求。
                  </p>
                </div>
                <div className="w-full md:w-1/2 px-4">
                  <div className="inline-flex items-center justify-center mb-4 w-12 h-12 text-xl text-white bg-blue-600 font-semibold rounded-full">
                    4
                  </div>
                  <h3 className="mb-2 text-base md:text-lg font-bold">
                    设备发布
                  </h3>
                  <p className=" text-slate-500">
                    你可以将符合指标的智能化设备正式的销售到终端客户。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <HomeNumbers />

      <HomePricing />

      <HomeTestimonials />

      <HomeFAQ />

      {/* <FreeTrial /> */}

      <Footer />

      {/* SDK下载弹窗 */}
      <SDKDownloadModal
        visible={isSdkModalVisible}
        onClose={handleModalClose}
        onDownload={handleSdkDownload}
      />
    </div>
  );
};

export default Home;
